export const Config = {
  Title: `ERP`,
  BillingUrl: `https://release-erp.geniuserp.review.genisys.cf/`,
  StripePublicKey: 'pk_test_5dWR3IfdlWhEAC6ccGZAzEsA',
  useV2API: false,
  useKhaltiV2Api: true
};


